module.exports = __webpack_public_path__ + "img/0Q3A7250_P_L_Wood_MockedUp.122ad5de.jpg";